import React, { useState } from "react";
import Calendar from "react-calendar";
import { useStateProvider } from "../common/StateProvider";

const ProfileCalendarPopUp = () => {
  const [dateState, setDateState] = useState(new Date());
  const changeDate = (e) => {
    setDateState(e);
  };
  const { setProfileCalendar } = useStateProvider();
  const { setQuickActionModal, setCreateFollowUpPopUp } = useStateProvider();

  const closeProfileCalendarModel = () => {
    setProfileCalendar(false);
    setQuickActionModal(false);
    setCreateFollowUpPopUp(false);
  };

  return (
    <>
      <div className="bg-white shadow-todays_workflow_box_shadow rounded-xl border border-solid border-[rgba(111,_106,_248,_0.10)] max-w-full">
        <p className=" text-black text-xs font-semibold pb-3 pt-5 pl-5">
          Select Date and Time
        </p>
        <Calendar
          className={"!w-[320px] xs:!w-[375px] xm:!w-[430px] md:!w-[500px]"}
          value={dateState}
          onChange={changeDate}
        />
        <div className=" flex justify-end pb-[18px] pr-[18px] pt-5">
          {" "}
          <button
            onClick={closeProfileCalendarModel}
            className="bg-primary text-white text-sm border border-solid border-transparent font-medium px-7 py-3 rounded-[36px] hover:bg-transparent hover:text-primary hover:border-primary duration-200 ">
            Save
          </button>
        </div>
      </div>
    </>
  );
};

export default ProfileCalendarPopUp;
